import { Trades } from '@src/containers/Blotters/Trades';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { TradesBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function TradesPanel({ params, api }: LayoutPanelProps<TradesBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.TradesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="trades-blotter-panel"
      >
        <Trades />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
